import { createAction } from '@ngrx/store';

export const FormRequestAction = createAction(
  '[Form] Request',
  (payload = null) => ({ payload })
);

export const FormRequestSuccessAction = createAction(
  '[Form] Request Success',
  (payload = null) => ({ payload })
);

export const FormRequestFailureAction = createAction(
  '[Form] Request Failure',
  (payload = null) => ({ payload })
);

export const FormRequestResetAction = createAction(
  '[Form] Request Reset',
  (payload = null) => ({ payload })
);

export const FormCreateAction = createAction(
  '[Form] Create',
  (payload = null) => ({ payload })
);

export const FormSubmitAction = createAction(
  '[Form] Submit',
  (payload = null) => ({ payload })
);
